function onYouTubeIframeAPIReady() {
  theme.SlideshowVideo.loadVideos();
}
function gm_authFailure() {
  $(".map-section").addClass("map-section--load-error"), $(".map-section__container").remove(), $(".map-section__link").remove(), $(".map-section__overlay").after('<div class="errors text-center">' + theme.strings.authError + "</div>");
}
(window.theme = window.theme || {}),
  (window.theme = window.theme || {}),
  (theme.Sections = function () {
      (this.constructors = {}),
          (this.instances = []),
          $(document)
              .on("shopify:section:load", this._onSectionLoad.bind(this))
              .on("shopify:section:unload", this._onSectionUnload.bind(this))
              .on("shopify:section:select", this._onSelect.bind(this))
              .on("shopify:section:deselect", this._onDeselect.bind(this))
              .on("shopify:block:select", this._onBlockSelect.bind(this))
              .on("shopify:block:deselect", this._onBlockDeselect.bind(this));
  }),
  (theme.Sections.prototype = _.assignIn({}, theme.Sections.prototype, {
      _createInstance: function (b, a) {
          var c = $(b),
              e = c.attr("data-section-id"),
              d = c.attr("data-section-type");
          if (((a = a || this.constructors[d]), !_.isUndefined(a))) {
              var f = _.assignIn(new a(b), { id: e, type: d, container: b });
              this.instances.push(f);
          }
      },
      _onSectionLoad: function (b) {
          var a = $("[data-section-id]", b.target)[0];
          a && this._createInstance(a);
      },
      _onSectionUnload: function (a) {
          this.instances = _.filter(this.instances, function (b) {
              var c = b.id === a.detail.sectionId;
              return c && _.isFunction(b.onUnload) && b.onUnload(a), !c;
          });
      },
      _onSelect: function (b) {
          var a = _.find(this.instances, function (a) {
              return a.id === b.detail.sectionId;
          });
          !_.isUndefined(a) && _.isFunction(a.onSelect) && a.onSelect(b);
      },
      _onDeselect: function (b) {
          var a = _.find(this.instances, function (a) {
              return a.id === b.detail.sectionId;
          });
          !_.isUndefined(a) && _.isFunction(a.onDeselect) && a.onDeselect(b);
      },
      _onBlockSelect: function (b) {
          var a = _.find(this.instances, function (a) {
              return a.id === b.detail.sectionId;
          });
          !_.isUndefined(a) && _.isFunction(a.onBlockSelect) && a.onBlockSelect(b);
      },
      _onBlockDeselect: function (b) {
          var a = _.find(this.instances, function (a) {
              return a.id === b.detail.sectionId;
          });
          !_.isUndefined(a) && _.isFunction(a.onBlockDeselect) && a.onBlockDeselect(b);
      },
      register: function (a, b) {
          (this.constructors[a] = b),
              $("[data-section-type=" + a + "]").each(
                  function (c, a) {
                      this._createInstance(a, b);
                  }.bind(this)
              );
      },
  })),
  (window.slate = window.slate || {}),
  (slate.rte = {
      wrapTable: function () {
          $(".rte table").wrap('<div class="rte__table-wrapper"></div>');
      },
      iframeReset: function () {
          var a = $('.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]'),
              b = a.add(".rte iframe#admin_bar_iframe");
          a.each(function () {
              $(this).wrap('<div class="video-wrapper"></div>');
          }),
              b.each(function () {
                  this.src = this.src;
              });
      },
  }),
  (window.slate = window.slate || {}),
  (slate.a11y = {
      pageLinkFocus: function (a) {
          var b = "js-focus-hidden";
          a.first()
              .attr("tabIndex", "-1")
              .focus()
              .addClass(b)
              .one("blur", function () {
                  a.first().removeClass(b).removeAttr("tabindex");
              });
      },
      focusHash: function () {
          var a = window.location.hash;
          window.location.hash.indexOf("?") >= 0 && a && document.getElementById(a.slice(1)) && this.pageLinkFocus($(a));
      },
      bindInPageLinks: function () {
          $("a[href*=#]").on(
              "click",
              function (a) {
                  this.pageLinkFocus($(a.currentTarget.hash));
              }.bind(this)
          );
      },
      trapFocus: function (a) {
          var b = a.namespace ? "focusin." + a.namespace : "focusin";
          a.$elementToFocus || (a.$elementToFocus = a.$container),
              a.$container.attr("tabindex", "-1"),
              a.$elementToFocus.focus(),
              $(document).off("focusin"),
              $(document).on(b, function (b) {
                  a.$container[0] === b.target || a.$container.has(b.target).length || a.$container.focus();
              });
      },
      removeTrapFocus: function (a) {
          var b = a.namespace ? "focusin." + a.namespace : "focusin";
          a.$container && a.$container.length && a.$container.removeAttr("tabindex"), $(document).off(b);
      },
  }),
  (theme.Images = {
      preload: function (a, c) {
          "string" == typeof a && (a = [a]);
          for (var b = 0; b < a.length; b++) {
              var d = a[b];
              this.loadImage(this.getSizedImageUrl(d, c));
          }
      },
      loadImage: function (a) {
          new Image().src = a;
      },
      switchImage: function (b, a, c) {
          var e = this.imageSize(a.src),
              d = this.getSizedImageUrl(b.src, e);
          c ? c(d, b, a) : (a.src = d);
      },
      imageSize: function (b) {
          var a = b.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);
          return null !== a ? a[1] : null;
      },
      getSizedImageUrl: function (a, b) {
          if (null == b) return a;
          if ("master" === b) return this.removeProtocol(a);
          var c = a.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
          if (null != c) {
              var d = a.split(c[0]),
                  e = c[0];
              return this.removeProtocol(d[0] + "_" + b + e);
          }
          return null;
      },
      removeProtocol: function (a) {
          return a.replace(/http(s)?:/, "");
      },
  }),
  (theme.Currency = {
      formatMoney: function (a, f) {
          "string" == typeof a && (a = a.replace(".", ""));
          var b = "",
              d = /\{\{\s*(\w+)\s*\}\}/,
              e = f || "${{amount}}";
          function c(a, b, c, d) {
              if (((b = b || 2), (c = c || ","), (d = d || "."), isNaN(a) || null == a)) return 0;
              var e = (a = (a / 100).toFixed(b)).split("."),
                  f = e[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + c),
                  g = e[1] ? d + e[1] : "";
              return f + g;
          }
          switch (e.match(d)[1]) {
              case "amount":
                  b = c(a, 2);
                  break;
              case "amount_no_decimals":
                  b = c(a, 0);
                  break;
              case "amount_with_comma_separator":
                  b = c(a, 2, ".", ",");
                  break;
              case "amount_no_decimals_with_comma_separator":
                  b = c(a, 0, ".", ",");
                  break;
              case "amount_no_decimals_with_space_separator":
                  b = c(a, 0, " ");
          }
          return e.replace(d, b);
      },
  }),
  (slate.Variants = (function () {
      function a(a) {
          (this.$container = a.$container),
              (this.product = a.product),
              (this.singleOptionSelector = a.singleOptionSelector),
              (this.originalSelectorId = a.originalSelectorId),
              (this.enableHistoryState = a.enableHistoryState),
              (this.currentVariant = this._getVariantFromOptions()),
              $(this.singleOptionSelector, this.$container).on("change", this._onSelectChange.bind(this));
      }
      return (
          (a.prototype = _.assignIn({}, a.prototype, {
              _getCurrentOptions: function () {
                  var a = _.map($(this.singleOptionSelector, this.$container), function (d) {
                      var a = $(d),
                          c = a.attr("type"),
                          b = {};
                      return "radio" !== c && "checkbox" !== c ? ((b.value = a.val()), (b.index = a.data("index")), b) : !!a[0].checked && ((b.value = a.val()), (b.index = a.data("index")), b);
                  });
                  return _.compact(a);
              },
              _getVariantFromOptions: function () {
                  var currentOptions = this._getCurrentOptions();
                  var variants = this.product.variants;
                  var foundVariant = variants.find(function (variant) {
                      return currentOptions.every(function (option) {
                          return variant[option.index] === option.value;
                      });
                  });
                //   console.log("foundVariant",foundVariant);
                  if (foundVariant)
                      for (var f = jQuery("#" + c.domIdPrefix).closest("form"), a = 0, g = foundVariant.options.length; a < g; a++) {
                          var b = f.find('.swatch[data-option-index="' + a + '"] :radio[value="' + foundVariant.options[a] + '"]');
                          b.size() && (b.get(0).checked = !0);
                      }
                  return foundVariant;
              },
              _onSelectChange: function () {
                  var a = this._getVariantFromOptions();
                  this.$container.trigger({ type: "variantChange", variant: a }),
                      a && (this._updateMasterSelect(a), this._updateImages(a), this._updatePrice(a), this._updateSKU(a), (this.currentVariant = a), this.enableHistoryState && this._updateHistoryState(a));
              },
              _updateImages: function (a) {
                  var b = a.featured_image || {},
                      c = this.currentVariant.featured_image || {};
                  a.featured_image && b.src !== c.src && this.$container.trigger({ type: "variantImageChange", variant: a });
              },
              _updatePrice: function (a) {
                  (a.price !== this.currentVariant.price || a.compare_at_price !== this.currentVariant.compare_at_price) && this.$container.trigger({ type: "variantPriceChange", variant: a });
              },
              _updateSKU: function (a) {
                  a.sku !== this.currentVariant.sku && this.$container.trigger({ type: "variantSKUChange", variant: a });
              },
              _updateHistoryState: function (a) {
                  if (history.replaceState && a) {
                      var b = window.location.protocol + "//" + window.location.host + window.location.pathname + "?variant=" + a.id;
                      window.history.replaceState({ path: b }, "", b);
                  }
              },
              _updateMasterSelect: function (a) {
                  $(this.originalSelectorId, this.$container).val(a.id);
              },
          })),
          a
      );
  })()),
  (theme.Drawers = (function () {
      function a(b, a, c) {
          if (
              ((this.nodes = { $parent: $("html").add("body"), $page: $("#PageContainer") }),
              (this.config = $.extend({ close: ".js-drawer-close", open: ".js-drawer-open-" + a, openClass: "js-drawer-open", dirOpenClass: "js-drawer-open-" + a }, c)),
              (this.position = a),
              (this.$drawer = $("#" + b)),
              !this.$drawer.length)
          )
              return !1;
          (this.drawerIsOpen = !1), this.init();
      }
      return (
          (a.prototype.init = function () {
              $(this.config.open).on("click", $.proxy(this.open, this)), this.$drawer.on("click", this.config.close, $.proxy(this.close, this));
          }),
          (a.prototype.open = function (a) {
              var b = !1;
              return (a ? a.preventDefault() : (b = !0), a && a.stopPropagation && (a.stopPropagation(), (this.$activeSource = $(a.currentTarget))), this.drawerIsOpen && !b)
                  ? this.close()
                  : (this.$drawer.prepareTransition(),
                    this.nodes.$parent.addClass(this.config.openClass + " " + this.config.dirOpenClass),
                    (this.drawerIsOpen = !0),
                    slate.a11y.trapFocus({ $container: this.$drawer, namespace: "drawer_focus" }),
                    this.config.onDrawerOpen && "function" == typeof this.config.onDrawerOpen && (b || this.config.onDrawerOpen()),
                    this.$activeSource && this.$activeSource.attr("aria-expanded") && this.$activeSource.attr("aria-expanded", "true"),
                    this.bindEvents(),
                    this);
          }),
          (a.prototype.close = function () {
              this.drawerIsOpen &&
                  ($(document.activeElement).trigger("blur"),
                  this.$drawer.prepareTransition(),
                  this.nodes.$parent.removeClass(this.config.dirOpenClass + " " + this.config.openClass),
                  (this.drawerIsOpen = !1),
                  slate.a11y.removeTrapFocus({ $container: this.$drawer, namespace: "drawer_focus" }),
                  this.unbindEvents());
          }),
          (a.prototype.bindEvents = function () {
              this.nodes.$parent.on(
                  "keyup.drawer",
                  $.proxy(function (a) {
                      return 27 !== a.keyCode || (this.close(), !1);
                  }, this)
              ),
                  this.nodes.$page.on("touchmove.drawer", function () {
                      return !1;
                  }),
                  this.nodes.$page.on(
                      "click.drawer",
                      $.proxy(function () {
                          return this.close(), !1;
                      }, this)
                  );
          }),
          (a.prototype.unbindEvents = function () {
              this.nodes.$page.off(".drawer"), this.nodes.$parent.off(".drawer");
          }),
          a
      );
  })()),
  (window.theme = window.theme || {}),
  (theme.Header = (function () {
      var a = {
              body: "body",
              navigation: "#AccessibleNav",
              siteNavHasDropdown: ".site-nav--has-dropdown",
              siteNavChildLinks: ".site-nav__child-link",
              siteNavActiveDropdown: ".site-nav--active-dropdown",
              siteNavLinkMain: ".site-nav__link--main",
              siteNavChildLink: ".site-nav__link--last",
          },
          b = { activeClass: "site-nav--active-dropdown", childLinkClass: "site-nav__child-link" },
          c = {};
      function d(d) {
          d.find(a.siteNavLinkMain).attr("aria-expanded", "false"),
              d.removeClass(b.activeClass),
              $("header.site-header").removeClass(b.activeClass),
              (c.$activeDropdown = $(a.siteNavActiveDropdown)),
              $(a.body).off("click.siteNav"),
              $(window).off("keyup.siteNav");
      }
      return {
          init: function () {
              (c = { $nav: $(a.navigation), $topLevel: $(a.siteNavLinkMain), $parents: $(a.navigation).find(a.siteNavHasDropdown), $subMenuLinks: $(a.siteNavChildLinks), $activeDropdown: $(a.siteNavActiveDropdown) }).$parents.on(
                  "click.siteNav",
                  function (f) {
                      var e,
                          g = $(this);
                      g.hasClass(b.activeClass) || (f.preventDefault(), f.stopImmediatePropagation()),
                          (e = g).addClass(b.activeClass),
                          $("header.site-header").addClass(b.activeClass),
                          c.$activeDropdown.length && d(c.$activeDropdown),
                          (c.$activeDropdown = e),
                          e.find(a.siteNavLinkMain).attr("aria-expanded", "true"),
                          setTimeout(function () {
                              $(window).on("keyup.siteNav", function (a) {
                                  27 === a.keyCode && d(e);
                              }),
                                  $(".page-container, .site-header .page-width.page-width--header").on("click.siteNav", function () {
                                      d(e);
                                  });
                          }, 250);
                  }
              ),
                  $(a.siteNavChildLink).on("focusout.siteNav", function () {
                      setTimeout(function () {
                          !$(document.activeElement).hasClass(b.childLinkClass) && c.$activeDropdown.length && d(c.$activeDropdown);
                      });
                  }),
                  c.$topLevel.on("focus.siteNav", function () {
                      c.$activeDropdown.length && d(c.$activeDropdown);
                  }),
                  c.$subMenuLinks.on("click.siteNav", function (a) {
                      a.stopImmediatePropagation();
                  });
          },
          unload: function () {
              $(window).off(".siteNav"), c.$parents.off(".siteNav"), c.$subMenuLinks.off(".siteNav"), c.$topLevel.off(".siteNav"), $(a.siteNavChildLink).off(".siteNav"), $(a.body).off(".siteNav");
          },
      };
  })()),
  (window.theme = window.theme || {}),
  (theme.MobileNav = (function () {
      var b,
          c,
          d,
          e = {
              mobileNavOpenIcon: "mobile-nav--open",
              mobileNavCloseIcon: "mobile-nav--close",
              subNavLink: "mobile-nav__sublist-link",
              return: "mobile-nav__return-btn",
              subNavActive: "is-active",
              subNavClosing: "is-closing",
              navOpen: "js-menu--is-open",
              subNavShowing: "sub-nav--is-open",
              thirdNavShowing: "third-nav--is-open",
              subNavToggleBtn: "js-toggle-submenu",
          },
          f = {},
          g = 1;
      function h() {
          f.$mobileNavToggle.hasClass(e.mobileNavCloseIcon) ? a() : i();
      }
      function i() {
          var b = f.$siteHeader.outerHeight() + f.$siteHeader.offset().top;
          f.$mobileNavContainer.prepareTransition().addClass(e.navOpen),
              f.$mobileNavContainer.css({ transform: "translate3d(0, " + b + "px, 0)" }),
              f.$pageContainer.css({ transform: "translate3d(0, " + f.$mobileNavContainer[0].scrollHeight + "px, 0)" }),
              slate.a11y.trapFocus({ $container: f.$mobileNav, namespace: "navFocus" }),
              f.$mobileNavToggle.addClass(e.mobileNavCloseIcon).removeClass(e.mobileNavOpenIcon),
              $(window).on("keyup.mobileNav", function (b) {
                  27 === b.which && a();
              });
      }
      function a() {
          f.$mobileNavContainer.prepareTransition().removeClass(e.navOpen),
              f.$mobileNavContainer.css({ transform: "translate3d(0, -100%, 0)" }),
              f.$pageContainer.removeAttr("style"),
              f.$mobileNavContainer.one("TransitionEnd.navToggle webkitTransitionEnd.navToggle transitionend.navToggle oTransitionEnd.navToggle", function () {
                  slate.a11y.removeTrapFocus({ $container: f.$mobileNav, namespace: "navFocus" });
              }),
              f.$mobileNavToggle.addClass(e.mobileNavOpenIcon).removeClass(e.mobileNavCloseIcon),
              $(window).off("keyup.mobileNav");
      }
      function j(c) {
          if (!b) {
              var a = $(c.currentTarget);
              (b = !0),
                  a.hasClass(e.return) ? ($("." + e.subNavToggleBtn + '[data-level="' + (g - 1) + '"]').removeClass(e.subNavActive), d && d.length && d.removeClass(e.subNavActive)) : a.addClass(e.subNavActive),
                  (d = a),
                  k(a.data("target"));
          }
      }
      function k(h) {
          var a = h ? $('.mobile-nav__dropdown[data-parent="' + h + '"]') : f.$mobileNav;
          (g = a.data("level") ? a.data("level") : 1), c && c.length && c.prepareTransition().addClass(e.subNavClosing), (c = a);
          var k = h ? a.find("." + e.subNavLink + ":first") : d,
              i = a[0].scrollHeight;
          h || (i = a.outerHeight());
          var j = g > 2 ? e.thirdNavShowing : e.subNavShowing;
          f.$mobileNavContainer.css("height", i).removeClass(e.thirdNavShowing).addClass(j),
              h || f.$mobileNavContainer.removeClass(e.thirdNavShowing).removeClass(e.subNavShowing),
              f.$mobileNavContainer.one("TransitionEnd.subnavToggle webkitTransitionEnd.subnavToggle transitionend.subnavToggle oTransitionEnd.subnavToggle", function () {
                  slate.a11y.trapFocus({ $container: a, $elementToFocus: k, namespace: "subNavFocus" }), f.$mobileNavContainer.off(".subnavToggle"), (b = !1);
              }),
              f.$pageContainer.css({ transform: "translate3d(0, " + i + "px, 0)" }),
              c.removeClass(e.subNavClosing);
      }
      return {
          init: function () {
              (f = {
                  $pageContainer: $("#PageContainer"),
                  $siteHeader: $(".site-header"),
                  $mobileNavToggle: $(".js-mobile-nav-toggle"),
                  $mobileNavContainer: $(".mobile-nav-wrapper"),
                  $mobileNav: $("#MobileNav"),
                  $subNavToggleBtn: $("." + e.subNavToggleBtn),
              }).$mobileNavToggle.on("click", h),
                  f.$subNavToggleBtn.on("click.subNav", j),
                  enquire.register("screen and (max-width: 768px)", {
                      unmatch: function () {
                          a();
                      },
                  });
          },
          closeMobileNav: a,
      };
  })(jQuery)),
  (window.theme = window.theme || {}),
  (theme.Search = (function () {
      var a = {
              search: ".search",
              searchSubmit: ".search__submit",
              searchInput: ".search__input",
              siteHeader: ".site-header",
              siteHeaderSearchToggle: ".site-header__search-toggle",
              siteHeaderSearch: ".site-header__search",
              searchDrawer: ".search-bar",
              searchDrawerInput: ".search-bar__input",
              searchHeader: ".search-header",
              searchHeaderInput: ".search-header__input",
              searchHeaderSubmit: ".search-header__submit",
              mobileNavWrapper: ".mobile-nav-wrapper",
          },
          b = { focus: "search--focus", mobileNavIsOpen: "js-menu--is-open" };
      function c() {
          d($(a.searchDrawerInput)), $(a.mobileNavWrapper).hasClass(b.mobileNavIsOpen) && theme.MobileNav.closeMobileNav();
      }
      function d(a) {
          a.focus(), a[0].setSelectionRange(0, a[0].value.length);
      }
      return {
          init: function () {
              $(a.siteHeader).length &&
                  ($("#PageContainer").addClass("drawer-page-content"),
                  $(".js-drawer-open-top").attr("aria-controls", "SearchDrawer").attr("aria-expanded", "false"),
                  (theme.SearchDrawer = new theme.Drawers("SearchDrawer", "top", { onDrawerOpen: c })),
                  $(a.searchSubmit).on("click", function (b) {
                      var c = $(b.target).parents(a.search).find(a.searchInput);
                      0 === c.val().length && (b.preventDefault(), d(c));
                  }),
                  $(a.searchHeaderInput)
                      .add(a.searchHeaderSubmit)
                      .on("focus blur", function () {
                          $(a.searchHeader).toggleClass(b.focus);
                      }),
                  $(a.siteHeaderSearchToggle).on("click", function () {
                      var b = $(a.siteHeader).outerHeight(),
                          c = $(a.siteHeader).offset().top - b;
                      $(a.searchDrawer).css({ height: b + "px", top: c + "px" });
                  }));
          },
      };
  })()),
  (function () {
      var a = $(".return-link");
      function b(b) {
          var a = document.createElement("a");
          return (a.ref = b), a.hostname;
      }
      document.referrer &&
          a.length &&
          window.history.length &&
          a.one("click", function (a) {
              a.preventDefault();
              var c = b(document.referrer),
                  d = b(window.location.href);
              return d === c && history.back(), !1;
          });
  })(),
  (theme.Slideshow = (function () {
      this.$slideshow = null;
      var b = {
          wrapper: "slideshow-wrapper",
          slideshow: "slideshow",
          currentSlide: "slick-current",
          video: "slideshow__video",
          videoBackground: "slideshow__video--background",
          closeVideoBtn: "slideshow__video-control--close",
          pauseButton: "slideshow__pause",
          isPaused: "is-paused",
      };
      function a(a) {
          (this.$slideshow = $(a)),
              (this.$wrapper = this.$slideshow.closest("." + b.wrapper)),
              (this.$pause = this.$wrapper.find("." + b.pauseButton)),
              (this.settings = { accessibility: !0, arrows: !0, infinite: !1, dots: !0, fade: !0, draggable: !0, touchThreshold: 20, autoplay: this.$slideshow.data("autoplay"), autoplaySpeed: this.$slideshow.data("speed") }),
              this.$slideshow.on("beforeChange", d.bind(this)),
              this.$slideshow.on("init", c.bind(this)),
              this.$slideshow.slick(this.settings),
              this.$pause.on("click", this.togglePause.bind(this));
      }
      function c(e, a) {
          var f = a.$slider,
              d = a.$list,
              c = this.$wrapper,
              g = this.settings.autoplay;
          d.removeAttr("aria-live"),
              c.on("focusin", function (a) {
                  c.has(a.target).length && (d.attr("aria-live", "polite"), g && f.slick("slickPause"));
              }),
              c.on("focusout", function (a) {
                  c.has(a.target).length && (d.removeAttr("aria-live"), g) && !$(a.target).hasClass(b.closeVideoBtn) && f.slick("slickPlay");
              }),
              a.$dots &&
                  a.$dots.on("keydown", function (b) {
                      37 === b.which && f.slick("slickPrev"), 39 === b.which && f.slick("slickNext"), (37 === b.which || 39 === b.which) && a.$dots.find(".slick-active button").focus();
                  });
      }
      function d(m, h, n, i) {
          var c = h.$slider,
              d = c.find("." + b.currentSlide),
              f = c.find('.slideshow__slide[data-slick-index="' + i + '"]');
          if (e(d)) {
              var g = d.find("." + b.video),
                  j = g.attr("id");
              theme.SlideshowVideo.pauseVideo(j), g.attr("tabindex", "-1");
          }
          if (e(f)) {
              var a = f.find("." + b.video),
                  k = a.attr("id"),
                  l = a.hasClass(b.videoBackground);
              l ? theme.SlideshowVideo.playVideo(k) : a.attr("tabindex", "0");
          }
      }
      function e(a) {
          return a.find("." + b.video).length;
      }
      return (
          (a.prototype.togglePause = function () {
              var c,
                  a = "#Slideshow-" + (c = this.$pause).data("id");
              this.$pause.hasClass(b.isPaused) ? (this.$pause.removeClass(b.isPaused), $(a).slick("slickPlay")) : (this.$pause.addClass(b.isPaused), $(a).slick("slickPause"));
          }),
          a
      );
  })()),
  (theme.SlideshowVideo = (function () {
      var a = !1,
          b = !1,
          c = !1,
          d = !1,
          e = !1,
          f = {},
          g = [],
          h = {
              ratio: 16 / 9,
              playerVars: { iv_load_policy: 3, modestbranding: 1, autoplay: 0, controls: 0, showinfo: 0, wmode: "opaque", branding: 0, autohide: 0, rel: 0 },
              events: {
                  onReady: function (b) {
                      b.target.setPlaybackQuality("hd1080");
                      var a = r(b);
                      switch ((c || (750 > $(window).width() ? (d = !0) : window.mobileCheck() && (d = !0), d && k(!1), (c = !0)), $("#" + a.id).attr("tabindex", "-1"), s(), a.type)) {
                          case "background-chrome":
                          case "background":
                              b.target.mute(), a.$parentSlide.hasClass(i.currentSlide) && j(a.id);
                      }
                      a.$parentSlide.addClass(i.loaded);
                  },
                  onStateChange: function (b) {
                      var a = r(b);
                      switch (b.data) {
                          case 0:
                              n(a);
                              break;
                          case 1:
                              o(a);
                              break;
                          case 2:
                              p(a);
                      }
                  },
              },
          },
          i = {
              playing: "video-is-playing",
              paused: "video-is-paused",
              loading: "video-is-loading",
              loaded: "video-is-loaded",
              slideshowWrapper: "slideshow-wrapper",
              slide: "slideshow__slide",
              slideBackgroundVideo: "slideshow__slide--background-video",
              slideDots: "slick-dots",
              videoChrome: "slideshow__video--chrome",
              videoBackground: "slideshow__video--background",
              playVideoBtn: "slideshow__video-control--play",
              closeVideoBtn: "slideshow__video-control--close",
              currentSlide: "slick-current",
              slickClone: "slick-cloned",
              supportsAutoplay: "autoplay",
              supportsNoAutoplay: "no-autoplay",
          };
      function j(c, k) {
          var e = f[c],
              h = g[c],
              j = f[c].$parentSlide;
          if (d) o(e);
          else if (k || (a && b)) {
              j.removeClass(i.loading), o(e), h.playVideo();
              return;
          }
          a || l(h, j);
      }
      function k(b) {
          var c = b ? i.supportsAutoplay : i.supportsNoAutoplay;
          $(document.documentElement).addClass(c), b || (d = !0), (a = !0);
      }
      function l(b, c) {
          b.playVideo(),
              m(b)
                  .then(function () {
                      k(!0);
                  })
                  .fail(function () {
                      k(!1), b.stopVideo();
                  })
                  .always(function () {
                      (a = !0), c.removeClass(i.loading);
                  });
      }
      function m(e) {
          var a,
              c,
              d = $.Deferred();
          return (
              (a = setInterval(function () {
                  0 >= e.getCurrentTime() || ((b = !0), clearInterval(a), clearTimeout(c), d.resolve());
              }, 500)),
              (c = setTimeout(function () {
                  clearInterval(a), d.reject();
              }, 4e3)),
              d
          );
      }
      function n(a) {
          switch (a.type) {
              case "background":
                  g[a.id].seekTo(0);
                  break;
              case "background-chrome":
                  g[a.id].seekTo(0), q(a.id);
                  break;
              case "chrome":
                  q(a.id);
          }
      }
      function o(a) {
          var c = a.$parentSlideshowWrapper,
              b = a.$parentSlide;
          if ((b.removeClass(i.loading), "background" !== a.status)) {
              switch (($("#" + a.id).attr("tabindex", "0"), a.type)) {
                  case "chrome":
                  case "background-chrome":
                      c.removeClass(i.paused).addClass(i.playing), b.removeClass(i.paused).addClass(i.playing);
              }
              b.find("." + i.closeVideoBtn).focus();
          }
      }
      function p(a) {
          var b = a.$parentSlideshowWrapper,
              c = a.$parentSlide;
          if ("background-chrome" === a.type) {
              q(a.id);
              return;
          }
          "closed" !== a.status && "background" !== a.type && (b.addClass(i.paused), c.addClass(i.paused)),
              "chrome" === a.type && "closed" === a.status && (b.removeClass(i.paused), c.removeClass(i.paused)),
              b.removeClass(i.playing),
              c.removeClass(i.playing);
      }
      function q(b) {
          var a = f[b],
              d = a.$parentSlideshowWrapper,
              e = a.$parentSlide,
              c = [i.pause, i.playing].join(" ");
          switch (($("#" + a.id).attr("tabindex", "-1"), (a.status = "closed"), a.type)) {
              case "background-chrome":
                  g[b].mute(), u(b);
                  break;
              case "chrome":
                  g[b].stopVideo(), p(a);
          }
          d.removeClass(c), e.removeClass(c);
      }
      function r(a) {
          return f[a.target.h.id];
      }
      function s() {
          $("." + i.videoBackground).each(function (b, a) {
              t($(a));
          });
      }
      function t(b) {
          var e = b.closest("." + i.slide);
          if (!e.hasClass(i.slickClone)) {
              var c = e.width(),
                  d = b.width(),
                  a = b.height();
              c / h.ratio < a
                  ? ((d = Math.ceil(a * h.ratio)),
                    b
                        .width(d)
                        .height(a)
                        .css({ left: (c - d) / 2, top: 0 }))
                  : ((a = Math.ceil(c / h.ratio)),
                    b
                        .width(c)
                        .height(a)
                        .css({ left: 0, top: (a - a) / 2 })),
                  b.prepareTransition().addClass(i.loaded);
          }
      }
      function u(a) {
          var b = $("#" + a)
              .addClass(i.videoBackground)
              .removeClass(i.videoChrome);
          f[a].$parentSlide.addClass(i.slideBackgroundVideo), (f[a].status = "background"), t(b);
      }
      function v() {
          $(document).on("click.videoPlayer", "." + i.playVideoBtn, function (a) {
              !(function (a) {
                  var b,
                      c = f[a];
                  switch ((c.$parentSlide.addClass(i.loading), (c.status = "open"), c.type)) {
                      case "background-chrome":
                          $("#" + (b = a))
                              .removeAttr("style")
                              .removeClass(i.videoBackground)
                              .addClass(i.videoChrome),
                              f[b].$parentSlideshowWrapper.removeClass(i.slideBackgroundVideo).addClass(i.playing),
                              f[b].$parentSlide.removeClass(i.slideBackgroundVideo).addClass(i.playing),
                              (f[b].status = "open"),
                              g[a].unMute(),
                              j(a, !0);
                          break;
                      case "chrome":
                          j(a, !0);
                  }
                  $(document).on("keydown.videoPlayer", function (b) {
                      27 === b.keyCode && q(a);
                  });
              })($(a.currentTarget).data("controls"));
          }),
              $(document).on("click.videoPlayer", "." + i.closeVideoBtn, function (a) {
                  var b = $(a.currentTarget).data("controls");
                  q(b);
              }),
              $(window).on(
                  "resize.videoPlayer",
                  $.debounce(250, function () {
                      e && s();
                  })
              );
      }
      return {
          init: function (a) {
              if (
                  a.length &&
                  ((f[a.attr("id")] = {
                      id: a.attr("id"),
                      videoId: a.data("id"),
                      type: a.data("type"),
                      status: "chrome" === a.data("type") ? "closed" : "background",
                      videoSelector: a.attr("id"),
                      $parentSlide: a.closest("." + i.slide),
                      $parentSlideshowWrapper: a.closest("." + i.slideshowWrapper),
                      controls: "background" === a.data("type") ? 0 : 1,
                      slideshow: a.data("slideshow"),
                  }),
                  !e)
              ) {
                  var b = document.createElement("script");
                  b.src = "https://www.youtube.com/iframe_api";
                  var c = document.getElementsByTagName("script")[0];
                  c.parentNode.insertBefore(b, c);
              }
          },
          loadVideos: function () {
              for (var a in f)
                  if (f.hasOwnProperty(a)) {
                      var b = $.extend({}, h, f[a]);
                      (b.playerVars.controls = b.controls), (g[a] = new YT.Player(a, b));
                  }
              v(), (e = !0);
          },
          loadVideo: function (a) {
              if (e) {
                  var b = $.extend({}, h, f[a]);
                  (b.playerVars.controls = b.controls), (g[a] = new YT.Player(a, b)), v();
              }
          },
          playVideo: function (a) {
              (c || d) && a && "function" == typeof g[a].playVideo && j(a);
          },
          pauseVideo: function (a) {
              g[a] && "function" == typeof g[a].pauseVideo && g[a].pauseVideo();
          },
          removeEvents: function () {
              $(document).off(".videoPlayer"), $(window).off(".videoPlayer");
          },
      };
  })()),
  (function () {
      var a = $("#BlogTagFilter");
      a.length &&
          a.on("change", function () {
              location.href = $(this).val();
          });
  })(),
  (window.theme = theme || {}),
  (theme.customerTemplates = (function () {
      function a() {
          $("#RecoverPasswordForm").toggleClass("hide"), $("#CustomerLoginForm").toggleClass("hide");
      }
      return {
          init: function () {
              var b, c;
              (b = window.location.hash),
                  window.location.hash.indexOf("#") >= 0 && "#recover" === b && a(),
                  $("#RecoverPassword").on("click", function (b) {
                      b.preventDefault(), a();
                  }),
                  $("#HideRecoverPasswordLink").on("click", function (b) {
                      b.preventDefault(), a();
                  }),
                  $(".reset-password-success").length && $("#ResetSuccess").removeClass("hide"),
                  (c = $("#AddressNewForm")),
                  c.length &&
                      (Shopify && new Shopify.CountryProvinceSelector("AddressCountryNew", "AddressProvinceNew", { hideElement: "AddressProvinceContainerNew" }),
                      $(".address-country-option").each(function () {
                          var a = $(this).data("form-id");
                          new Shopify.CountryProvinceSelector("AddressCountry_" + a, "AddressProvince_" + a, { hideElement: "AddressProvinceContainer_" + a });
                      }),
                      $(".address-new-toggle").on("click", function () {
                          c.toggleClass("hide");
                      }),
                      $(".address-edit-toggle").on("click", function () {
                          var a = $(this).data("form-id");
                          $("#EditAddress_" + a).toggleClass("hide");
                      }),
                      $(".address-delete").on("click", function () {
                          var a = $(this),
                              b = a.data("form-id"),
                              c = a.data("confirm-message");
                          confirm(c || "Are you sure you wish to delete this address?") && Shopify.postLink("/account/addresses/" + b, { parameters: { _method: "delete" } });
                      }));
          },
      };
  })()),
  (window.theme = window.theme || {}),
  (theme.Cart = (function () {
      var b = { edit: ".js-edit-toggle" },
          c = { showClass: "cart__update--show", showEditClass: "cart__edit--active", cartNoCookies: "cart--no-cookies" };
      function a(a) {
          (this.$container = $(a)), (this.$edit = $(b.edit, this.$container)), this.cookiesEnabled() || this.$container.addClass(c.cartNoCookies), this.$edit.on("click", this._onEditClick.bind(this));
      }
      return (
          (a.prototype = _.assignIn({}, a.prototype, {
              onUnload: function () {
                  this.$edit.off("click", this._onEditClick);
              },
              _onEditClick: function (b) {
                  var a = $(b.target),
                      d = $("." + a.data("target"));
                  a.toggleClass(c.showEditClass), d.toggleClass(c.showClass);
              },
              cookiesEnabled: function () {
                  var a = navigator.cookieEnabled;
                  return a || ((document.cookie = "testcookie"), (a = -1 !== document.cookie.indexOf("testcookie"))), a;
              },
          })),
          a
      );
  })()),
  (window.theme = window.theme || {}),
  (theme.Filters = (function () {
      var b = { SORT_BY: "sort_by" },
          c = { filterSelection: ".filters-toolbar__input--filter", sortSelection: ".filters-toolbar__input--sort", defaultSort: ".collection-header__default-sort" };
      function a(b) {
          var a = (this.$container = $(b));
          (this.$filterSelect = $(c.filterSelection, a)),
              (this.$sortSelect = $(c.sortSelection, a)),
              (this.$selects = $(c.filterSelection, a).add($(c.sortSelection, a))),
              (this.defaultSort = this._getDefaultSortValue()),
              this._resizeSelect(this.$selects),
              this.$selects.removeClass("hidden"),
              this.$filterSelect.on("change", this._onFilterChange.bind(this)),
              this.$sortSelect.on("change", this._onSortChange.bind(this));
      }
      return (
          (a.prototype = _.assignIn({}, a.prototype, {
              _onSortChange: function (b) {
                  var a = this._sortValue();
                  a.length ? (window.location.search = a) : (window.location.href = window.location.href.replace(window.location.search, "")), this._resizeSelect($(b.target));
              },
              _onFilterChange: function (a) {
                  (window.location.href = this.$filterSelect.val() + window.location.search), this._resizeSelect($(a.target));
              },
              _getSortValue: function () {
                  return this.$sortSelect.val() || this.defaultSort;
              },
              _getDefaultSortValue: function () {
                  return $(c.defaultSort, this.$container).val();
              },
              _sortValue: function () {
                  var a = this._getSortValue(),
                      c = "";
                  return a !== this.defaultSort && (c = b.SORT_BY + "=" + a), c;
              },
              _resizeSelect: function (a) {
                  a.each(function () {
                      var b = $(this),
                          c = b.find("option:selected").text(),
                          a = $("<span>").html(c);
                      a.appendTo("body");
                      var d = a.width();
                      a.remove(), b.width(d + 10);
                  });
              },
              onUnload: function () {
                  this.$filterSelect.off("change", this._onFilterChange), this.$sortSelect.off("change", this._onSortChange);
              },
          })),
          a
      );
  })()),
  (window.theme = window.theme || {}),
  (theme.HeaderSection = (function () {
      function a() {
          theme.Header.init(), theme.MobileNav.init(), theme.Search.init();
      }
      return (
          (a.prototype = _.assignIn({}, a.prototype, {
              onUnload: function () {
                  theme.Header.unload();
              },
          })),
          a
      );
  })()),
  (theme.Maps = (function () {
      var b = { zoom: 14 },
          c = null,
          d = [],
          e = theme.mapKey ? theme.mapKey : "";
      function a(a) {
          (this.$container = $(a)),
              "loaded" === c
                  ? this.createMap()
                  : (d.push(this),
                    "loading" !== c &&
                        ((c = "loading"),
                        void 0 === window.google &&
                            $.getScript("https://maps.googleapis.com/maps/api/js?key=" + e).then(function () {
                                (c = "loaded"), f();
                            })));
      }
      function f() {
          $.each(d, function (b, a) {
              a.createMap();
          });
      }
      return (
          (a.prototype = _.assignIn({}, a.prototype, {
              createMap: function () {
                  var a,
                      c,
                      d,
                      e,
                      f = this.$container.find(".map-section__container");
                  return ((a = f),
                  (c = $.Deferred()),
                  (d = new google.maps.Geocoder()),
                  (e = a.data("address-setting")),
                  d.geocode({ address: e }, function (b, a) {
                      a !== google.maps.GeocoderStatus.OK && c.reject(a), c.resolve(b);
                  }),
                  c)
                      .then(
                          function (c) {
                              var d = { zoom: b.zoom, center: c[0].geometry.location, disableDefaultUI: !0 },
                                  a = (this.map = new google.maps.Map(f[0], d)),
                                  e = (this.center = a.getCenter());
                              new google.maps.Marker({ map: a, position: a.getCenter() }),
                                  google.maps.event.addDomListener(
                                      window,
                                      "resize",
                                      $.debounce(250, function () {
                                          google.maps.event.trigger(a, "resize"), a.setCenter(e);
                                      })
                                  );
                          }.bind(this)
                      )
                      .fail(function () {
                          var a;
                          switch (status) {
                              case "ZERO_RESULTS":
                                  a = theme.strings.addressNoResults;
                                  break;
                              case "OVER_QUERY_LIMIT":
                                  a = theme.strings.addressQueryLimit;
                                  break;
                              default:
                                  a = theme.strings.addressError;
                          }
                          f.parent()
                              .addClass("page-width map-section--load-error")
                              .html('<div class="errors text-center">' + a + "</div>");
                      });
              },
              onUnload: function () {
                  google.maps.event.clearListeners(this.map, "resize");
              },
          })),
          a
      );
  })()),
  (theme.Product = (function () {
      function a(c) {
          var b = (this.$container = $(c)),
              a = b.attr("data-section-id");
            (this.settings = {
              mediaQueryMediumUp: "screen and (min-width: 750px)",
              mediaQuerySmall: "screen and (max-width: 768px)",
              bpSmall: !1,
              enableHistoryState: b.data("enable-history-state") || !1,
              imageSize: null,
              imageZoomSize: null,
              namespace: ".slideshow-" + a,
              sectionId: a,
              sliderActive: !1,
              zoomEnabled: !1,
            }),
              (this.selectors = {
                  addToCart: "#AddToCart-" + a,
                  addToCartText: "#AddToCartText-" + a,
                  comparePrice: "#ComparePrice-" + a,
                  originalPrice: "#ProductPrice-" + a,
                  SKU: ".variant-sku",
                  originalPriceWrapper: ".product-price__price-" + a,
                  originalSelectorId: "#ProductSelect-" + a,
                  productFeaturedImage: "#FeaturedImage-" + a,
                  productImageWrap: "#FeaturedImageZoom-" + a,
                  productPrices: ".product-single__price-" + a,
                  productThumbImages: ".product-single__thumbnail--" + a,
                  productThumbs: ".product-single__thumbnails-" + a,
                  saleClasses: "product-price__sale product-price__sale--single",
                  saleLabel: ".product-price__sale-label-" + a,
                  singleOptionSelector: ".single-option-selector-" + a,
              }),
              $("#ProductJson-" + a).html() &&
                  ((this.productSingleObject = JSON.parse(document.getElementById("ProductJson-" + a).innerHTML)),
                  (this.settings.zoomEnabled = $(this.selectors.productFeaturedImage).hasClass("js-zoom-enabled")),
                  (this.settings.imageSize = theme.Images.imageSize($(this.selectors.productFeaturedImage).attr("src"))),
                  this.settings.zoomEnabled && (this.settings.imageZoomSize = theme.Images.imageSize($(this.selectors.productImageWrap).data("zoom"))),
                  this._initBreakpoints(),
                  this._stringOverrides(),
                  this._initVariants(),
                  this._initImageSwitch(),
                  this._setActiveThumbnail(),
                  theme.Images.preload(this.productSingleObject.images, this.settings.imageSize));
      }
      function b(a) {
          var b = a.data("zoom");
          a.zoom({ url: b });
      }
      function c(a) {
          a.trigger("zoom.destroy");
      }
      return (
          (a.prototype = _.assignIn({}, a.prototype, {
              _stringOverrides: function () {
                  (theme.productStrings = theme.productStrings || {}), $.extend(theme.strings, theme.productStrings);
              },
              _initBreakpoints: function () {
                  var a = this;
                  enquire.register(this.settings.mediaQuerySmall, {
                      match: function () {
                          $(a.selectors.productThumbImages).length > 1 && a._initThumbnailSlider(), a.settings.zoomEnabled && c($(a.selectors.productImageWrap)), (a.settings.bpSmall = !0);
                      },
                      unmatch: function () {
                          a.settings.sliderActive && a._destroyThumbnailSlider(), (a.settings.bpSmall = !1);
                      },
                  }),
                      enquire.register(this.settings.mediaQueryMediumUp, {
                          match: function () {
                              a.settings.zoomEnabled && b($(a.selectors.productImageWrap));
                          },
                      });
              },
              _initVariants: function () {
                  var a = {
                      $container: this.$container,
                      enableHistoryState: this.$container.data("enable-history-state") || !1,
                      singleOptionSelector: this.selectors.singleOptionSelector,
                      originalSelectorId: this.selectors.originalSelectorId,
                      product: this.productSingleObject,
                  };
                //   console.log("current variant",a);
                  (this.variants = new slate.Variants(a)),
                    //   console.log("55kk"),
                      this.$container.on("variantChange" + this.settings.namespace, this._updateAddToCart.bind(this)),
                      this.$container.on("variantImageChange" + this.settings.namespace, this._updateImages.bind(this)),
                      this.$container.on("variantPriceChange" + this.settings.namespace, this._updatePrice.bind(this)),
                      this.$container.on("variantSKUChange" + this.settings.namespace, this._updateSKU.bind(this));
              },
              _initImageSwitch: function () {
                  if ($(this.selectors.productThumbImages).length) {
                      var a = this;
                      $(this.selectors.productThumbImages).on("click", function (d) {
                          if ((d.preventDefault(), $(window).width() > 767)) {
                              var b = $(this),
                                  c = b.attr("href"),
                                  e = b.data("zoom");
                              a._switchImage(c, e), a._setActiveThumbnail(c);
                          }
                      }),
                          $(".fancy-box")
                              .find("img")
                              .on("click", function () {
                                //   console.log("asasas"),
                                      767 >= $(window).width() &&
                                          setTimeout(function () {
                                              $.fancybox.open({ src: "#easyvideo_video" });
                                          }, 500);
                              });
                  }
              },
              _setActiveThumbnail: function (a) {
                  var b = "active-thumb";
                  void 0 === a && (a = $(this.selectors.productFeaturedImage).attr("src"));
                  var c = $(this.selectors.productThumbImages + '[href="' + a + '"]');
                  $(this.selectors.productThumbImages).removeClass(b), c.addClass(b);
              },
              _switchImage: function (d, a) {
                  $(this.selectors.productFeaturedImage).attr("src", d),
                      this.settings.zoomEnabled && c($(this.selectors.productImageWrap)),
                      !this.settings.bpSmall && this.settings.zoomEnabled && a && ($(this.selectors.productImageWrap).data("zoom", a), b($(this.selectors.productImageWrap)));
              },
              _initThumbnailSlider: function () {
                  var a = {
                      slidesToScroll: 1,
                      infinite: !1,
                      prevArrow: ".thumbnails-slider__prev--" + this.settings.sectionId,
                      nextArrow: ".thumbnails-slider__next--" + this.settings.sectionId,
                      responsive: [{ breakpoint: 767, settings: { slidesToShow: 4 } }],
                  };
                  $(this.selectors.productThumbs).slick(a), (this.settings.sliderActive = !0);
              },
              _destroyThumbnailSlider: function () {
                  $(this.selectors.productThumbs).slick("unslick"), (this.settings.sliderActive = !1);
              },
              _updateAddToCart: function (b) {
                  var a = b.variant;
                  a
                      ? ($(this.selectors.productPrices).removeClass("visibility-hidden").attr("aria-hidden", "true"),
                        a.available
                            ? ($(this.selectors.addToCart).prop("disabled", !1), $(this.selectors.addToCartText).text(theme.strings.addToCart))
                            : ($(this.selectors.addToCart).prop("disabled", !0), $(this.selectors.addToCartText).text(theme.strings.soldOut)))
                      : ($(this.selectors.addToCart).prop("disabled", !0), $(this.selectors.addToCartText).text(theme.strings.unavailable), $(this.selectors.productPrices).addClass("visibility-hidden").attr("aria-hidden", "false"));
              },
              _updateImages: function (d) {
                  var a,
                      b = d.variant,
                      c = theme.Images.getSizedImageUrl(b.featured_image.src, this.settings.imageSize);
                  this.settings.zoomEnabled && (a = theme.Images.getSizedImageUrl(b.featured_image.src, this.settings.imageZoomSize)), this._switchImage(c, a), this._setActiveThumbnail(c);
              },
              _updatePrice: function (b) {
                  var a = b.variant;
                  $(this.selectors.originalPrice).html(theme.Currency.formatMoney(a.price, theme.moneyFormat)),
                      a.compare_at_price > a.price
                          ? ($(this.selectors.comparePrice).html(theme.Currency.formatMoney(a.compare_at_price, theme.moneyFormat)).removeClass("hide"),
                            $(this.selectors.originalPriceWrapper).addClass(this.selectors.saleClasses),
                            $(this.selectors.saleLabel).removeClass("hide"))
                          : ($(this.selectors.comparePrice).addClass("hide"), $(this.selectors.saleLabel).addClass("hide"), $(this.selectors.originalPriceWrapper).removeClass(this.selectors.saleClasses));
              },
              _updateSKU: function (a) {
                  var b = a.variant;
                  $(this.selectors.SKU).html(b.sku);
              },
              onUnload: function () {
                  this.$container.off(this.settings.namespace);
              },
          })),
          a
      );
  })()),
  (theme.Quotes = (function () {
      var b = { mediaQuerySmall: "screen and (max-width: 749px)", mediaQueryMediumUp: "screen and (min-width: 750px)", slideCount: 0 },
          c = { accessibility: !0, arrows: !1, dots: !0, autoplay: !1, touchThreshold: 20, slidesToShow: 3, slidesToScroll: 3 };
      function a(d) {
          var e = (this.$container = $(d)).attr("data-section-id"),
              f = (this.wrapper = ".quotes-wrapper"),
              a = $((this.slider = "#Quotes-" + e), f),
              g = !1,
              h = $.extend({}, c, { slidesToShow: 1, slidesToScroll: 1, adaptiveHeight: !0 });
          function i(a, b) {
              g && (a.slick("unslick"), (g = !1)), a.slick(b), (g = !0);
          }
          (b.slideCount = a.data("count")),
              b.slideCount < c.slidesToShow && ((c.slidesToShow = b.slideCount), (c.slidesToScroll = b.slideCount)),
              a.on("init", this.a11y.bind(this)),
              enquire.register(b.mediaQuerySmall, {
                  match: function () {
                      i(a, h);
                  },
              }),
              enquire.register(b.mediaQueryMediumUp, {
                  match: function () {
                      i(a, c);
                  },
              });
      }
      return (
          (a.prototype = _.assignIn({}, a.prototype, {
              onUnload: function () {
                  enquire.unregister(b.mediaQuerySmall), enquire.unregister(b.mediaQueryMediumUp), $(this.slider, this.wrapper).slick("unslick");
              },
              onBlockSelect: function (a) {
                  var b = $(".quotes-slide--" + a.detail.blockId + ":not(.slick-cloned)").data("slick-index");
                  $(this.slider, this.wrapper).slick("slickGoTo", b);
              },
              a11y: function (d, b) {
                  var c = b.$list,
                      a = $(this.wrapper, this.$container);
                  c.removeAttr("aria-live"),
                      a.on("focusin", function (b) {
                          a.has(b.target).length && c.attr("aria-live", "polite");
                      }),
                      a.on("focusout", function (b) {
                          a.has(b.target).length && c.removeAttr("aria-live");
                      });
              },
          })),
          a
      );
  })()),
  (theme.slideshows = {}),
  (theme.SlideshowSection = function (b) {
      var c = (this.$container = $(b)).attr("data-section-id"),
          a = (this.slideshow = "#Slideshow-" + c);
      $(".slideshow__video", a).each(function () {
          var a = $(this);
          theme.SlideshowVideo.init(a), theme.SlideshowVideo.loadVideo(a.attr("id"));
      }),
          (theme.slideshows[a] = new theme.Slideshow(a));
  }),
  (theme.SlideshowSection.prototype = _.assignIn({}, theme.SlideshowSection.prototype, {
      onUnload: function () {
          delete theme.slideshows[this.slideshow];
      },
      onBlockSelect: function (a) {
          var b = $(this.slideshow),
              c = $(".slideshow__slide--" + a.detail.blockId + ":not(.slick-cloned)"),
              d = c.data("slick-index");
          b.slick("slickGoTo", d).slick("slickPause");
      },
      onBlockDeselect: function () {
          $(this.slideshow).slick("slickPlay");
      },
  })),
  $(document).ready(function () {
      var a = new theme.Sections();
      a.register("cart-template", theme.Cart),
          a.register("product", theme.Product),
          a.register("collection-template", theme.Filters),
          a.register("product-template", theme.Product),
          a.register("header-section", theme.HeaderSection),
          a.register("map", theme.Maps),
          a.register("slideshow-section", theme.SlideshowSection),
          a.register("quotes", theme.Quotes);
  }),
  jQuery(function () {
      jQuery(".swatch :radio").change(function () {
          var a = jQuery(this).closest(".swatch").attr("data-option-index"),
              b = jQuery(this).val();
          jQuery(this).closest("form").find(".single-option-selector").eq(a).val(b).trigger("change");
      });
  }),
  (theme.init = function () {
      theme.customerTemplates.init(),
          slate.rte.wrapTable(),
          slate.rte.iframeReset(),
          window.location.hash.indexOf("?") >= 0 &&
              (slate.a11y.pageLinkFocus($(window.location.hash)),
              $(".in-page-link").on("click", function (a) {
                  slate.a11y.pageLinkFocus($(a.currentTarget.hash));
              }),
              $('a[href="#"]').on("click", function (a) {
                  a.preventDefault();
              }));
  }),
  $(theme.init),
  $(window).resize(function () {
      767 >= $(this).width() &&
          setTimeout(function () {
              var a = $(".fancy-box").find("img").attr("alt");
              if (void 0 != a && "" != a) {
                  var b = (a = a.split("/"))[a.length - 1];
                  $("#easyvideo_video").html('<iframe width="100%" src="https://www.youtube.com/embed/' + b + '?rel=0&amp;autoplay=0" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen="" height="169"></iframe>'),
                      $("#easyvideo_video").hide();
              }
          }, 1e3);
  }),
  $(window).load(function () {
      setTimeout(function () {
          var a = $(".fancy-box").find("img").attr("alt");
          if (void 0 != a && "" != a) {
              var b = (a = a.split("/"))[a.length - 1];
              $("#easyvideo_video").html('<iframe width="100%" src="https://www.youtube.com/embed/' + b + '?rel=0&amp;autoplay=0" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen="" height="169"></iframe>'),
                  $("#easyvideo_video").hide();
          }
      }, 1e3);
  }),
  $(".unlock_btn").on("click", function () {
      var a = "";
      $(".input_group")
          .find("input")
          .each(function () {
              a += $(this).val();
          }),
          (a = a.toLowerCase()),
          $("#passwordcode").val() == a
              ? ($.cookie("set", "yes", { expires: 1, path: "/" }), window.location.replace($("#afterunlock").val()))
              : ($(".input_group").after('<p class="error">Code is wrong!</p>'),
                setTimeout(function () {
                    $(".error").remove();
                }, 5e3));
  }),
  $(".treasurehunt-content a, .slide_arrow_icon").click(function () {
      return $("html, body").animate({ scrollTop: $($(this).attr("href")).offset().top }, 500), !1;
  }),
  $(document).ready(function () {
      $(".burger").click(function () {
          $(".site-header").hasClass("opened") ? $(".site-header").removeClass("opened") : $(".site-header").addClass("opened");
      });
  }),
  $(function () {
      $("li.telephone_drp > a").on("click", function (a) {
          a.preventDefault(),
              $(".site-header").hasClass("opened")
                  ? ($(".burger").trigger("click"), $(this).parent().find("ul").first().toggle(200), $(this).parent().siblings().find("ul").hide(100))
                  : ($(this).parent().find("ul").first().toggle(200), $(this).parent().siblings().find("ul").hide(100));
      }),
          $(document).on("click", function (b) {
              var a = $(b.target);
              a.parents("li").hasClass("telephone_drp") || a.parents("ul").hasClass("icon-ul") || $(".icon-ul").hide(100);
          });
  }),
  $(document).ready(function () {
      $(".has-sub").on("click", function () {
          $(this).toggleClass("active"), $(this).next("ul").slideToggle();
      });
      let a = $(".bucket-item");
      a.slick({
          dots: !1,
          infinite: !1,
          speed: 300,
          slidesToShow: a.children().length,
          slidesToScroll: a.children().length,
          responsive: (function (d) {
              a.addClass("max-width-items");
              for (
                  var c = [
                          { breakpoint: 1230, settings: { slidesToShow: 3, slidesToScroll: 3 } },
                          { breakpoint: 930, settings: { slidesToShow: 2, slidesToScroll: 2 } },
                          { breakpoint: 700, settings: { slidesToShow: 1, slidesToScroll: 1 } },
                      ],
                      b = 1;
                  b <= d;
                  b++
              )
                  c.push({ breakpoint: 410 * b, settings: { slidesToShow: b, slidesToScroll: b } });
              return console.info(c), c;
          })(a.children().length),
      });
  }),
  $("label.menu-label_").on("click", function () {
      $("header.site-header.border-bottom.logo--left").toggleClass("opened1");
  });
var QtyInput = (function () {
  var a = $(".qty-input");
  if (a.length) {
      var b = a.find(".product-qty"),
          c = a.find(".qty-count"),
          d = parseInt(b.attr("min")),
          e = parseInt(b.attr("max"));
      b.change(function () {
          var a = $(this),
              c = a.siblings(".qty-count--minus"),
              f = a.siblings(".qty-count--add"),
              b = parseInt(a.val());
          isNaN(b) || b <= d ? (a.val(d), c.attr("disabled", !0)) : (c.attr("disabled", !1), b >= e ? (a.val(e), f.attr("disabled", !0)) : (a.val(b), f.attr("disabled", !1)));
      }),
          c.click(function () {
              var f = this.dataset.action,
                  b = $(this),
                  c = b.siblings(".product-qty"),
                  a = parseInt(c.val());
              "add" == f
                  ? ((a += 1) >= d + 1 && b.siblings(".qty-count--minus").attr("disabled", !1), a >= e && b.attr("disabled", !0))
                  : ((a = a <= d ? d : (a -= 1)) == d && b.attr("disabled", !0), a < e && b.siblings(".qty-count--add").attr("disabled", !1)),
                  c.val(a);
          });
  }
})();
$(".burger").click(function () {
  $(".close_btn").show(), $(".burger").hide();
}),
  $(".close_btn").click(function () {
      $(".burger").show(), $(".close_btn").hide();
  }),
  $(".counting").each(function () {
      var a = $(this),
          b = a.attr("data-count");
      $({ countNum: a.text() }).animate(
          { countNum: b },
          {
              duration: 3e3,
              easing: "linear",
              step: function () {
                  a.text(Math.floor(this.countNum));
              },
              complete: function () {
                  a.text(this.countNum);
              },
          }
      );
  }),
  (equalheight = function (a) {
      var b,
          c = 0,
          d = 0,
          e = new Array();
      $(a).each(function () {
          if (((b = $(this)), $(b).height("auto"), (topPostion = b.position().top), d != topPostion)) {
              for (currentDiv = 0; currentDiv < e.length; currentDiv++) e[currentDiv].height(c);
              (e.length = 0), (d = topPostion), (c = b.height()), e.push(b);
          } else e.push(b), (c = c < b.height() ? b.height() : c);
          for (currentDiv = 0; currentDiv < e.length; currentDiv++) e[currentDiv].height(c);
      });
  }),
  $(window).load(function () {
      equalheight(".content_height");
  }),
  $(window).resize(function () {
      equalheight(".content_height");
  }),
  $(window).load(function () {
      equalheight(".rte-setting");
  }),
  $(window).resize(function () {
      equalheight(".rte-setting");
  }),
  $(window).load(function () {
      equalheight(".usp_box_cont");
  }),
  $(window).resize(function () {
      equalheight(".usp_box_cont");
  }),
  $(window).load(function () {
      equalheight(".row.box-width .address .add_detail");
  }),
  $(window).resize(function () {
      equalheight(".row.box-width .address .add_detail");
  }),
  $(window).load(function () {
      equalheight(".product_list_new .h4.grid-view-item__title");
  }),
  $(window).resize(function () {
      equalheight(".product_list_new .h4.grid-view-item__title");
  });
var $titleTab = $(".title_tab");
function myIfram() {
  document.getElementById("expertips_iframe").contentWindow.document.body.style.backgroundColor = "red";
}
$(".Accordion_item:eq(0)").find(".title_tab").addClass("active").next().stop().slideDown(300),
  $(".Accordion_item:eq(0)").find(".inner_content").find("p").addClass("show"),
  $titleTab.on("click", function (a) {
      a.preventDefault(),
          $(this).hasClass("active")
              ? ($(this).removeClass("active"), $(this).next().stop().slideUp(500), $(this).next().find("p").removeClass("show"))
              : ($(this).addClass("active"),
                $(this).next().stop().slideDown(500),
                $(this).parent().siblings().children(".title_tab").removeClass("active"),
                $(this).parent().siblings().children(".inner_content").slideUp(500),
                $(this).parent().siblings().children(".inner_content").find("p").removeClass("show"),
                $(this).next().find("p").addClass("show"));
  }),
  $(".cart_p_name").on("click", function () {
      $(".shopping-cart").css("display", "none");
  }),
  $("#cart_mobile").click(function (a) {
      a.preventDefault(), a.stopPropagation(), $(".shopping-cart").toggle();
  }),
  $("#cart").click(function (a) {
      a.preventDefault(), a.stopPropagation(), $(".shopping-cart").toggle();
  }),
  $("#cart_close").click(function (a) {
      a.preventDefault(), a.stopPropagation(), $(".shopping-cart").toggle();
  }),
  $(".shopping-cart").click(function (a) {
      a.stopPropagation();
  }),
  $("body").click(function () {
      $(".shopping-cart").hide();
  }),
  $(".myac").click(function (a) {
      a.preventDefault(), a.stopPropagation(), $(".myaccount_dp").toggle();
  }),
  $("body").click(function () {
      $(".myaccount_dp").hide();
  }),
  $(function () {
      $("li.tmenu_item")
          .mouseenter(function () {
              $("li.tmenu_item").addClass("tmenu_item_active");
          })
          .mouseleave(function () {
              $("li.tmenu_item").removeClass("tmenu_item_active");
          });
  }),
  $(".need_help_left a").on("click", function () {
      $("#sr-qu").addClass("ui-state-active"),
          $("#tabs-8").css({ display: "block" }),
          $("#tabs-2").css({ display: "none" }),
          $("#tabs-3").css({ display: "none" }),
          $("#tabs-4").css({ display: "none" }),
          $("#tabs-5").css({ display: "none" }),
          $("#tabs-6").css({ display: "none" }),
          $("#tabs-7").css({ display: "none" }),
          $(".right-child ul li:nth-child(2)").removeClass("ui-state-active"),
          $(".right-child ul li:nth-child(3)").removeClass("ui-state-active"),
          $(".right-child ul li:nth-child(4)").removeClass("ui-state-active"),
          $(".right-child ul li:nth-child(5)").removeClass("ui-state-active"),
          $(".right-child ul li:nth-child(6)").removeClass("ui-state-active");
  }),
  $(".right-child ul li:first a").on("click", function () {
      $(".tab_left #tabs-2").css({ display: "block" }), $(".right-child ul li:first").addClass("ui-state-active"), $(".right-child ul li:first").addClass("ui-tabs-active");
  }),
  $(".right-child ul li a").on("click", function () {
      $("#tabs-8").css({ display: "none" }), $(".right-child ul li:last").removeClass("ui-state-active"), $(".right-child ul li:last").removeClass("ui-tabs-active");
  }),
  // $(".right-child ul li:last a").on("click", function () {
  //     $("#tabs-8").css({ display: "block" }), $(".right-child ul li:last").addClass("ui-state-active");
  // }),
  $(".need_help_left a").on("click", function () {
      $(".right-child ul li:first").removeClass("ui-state-active"), $(".right-child ul li:first").removeClass("ui-tabs-active");
  });
const $menu = $("details.filter-group");
$(document).mouseup((a) => {
  $menu.is(a.target) || 0 !== $menu.has(a.target).length || $menu.removeAttr("open");
});
